import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import DeveloperCell from "./Developers";
import { Box, MenuItem, Select, Tooltip, Menu, Typography, IconButton, FormControl } from "@mui/material";
import { fetchAllEntities, getWeeklyTaskAllocation, updateWeeklyTaskAllocation } from "../../apis/apiService";
import { setownerNameOptions } from "../../selectSlice";
import { toast } from "react-toastify";
import SearchBar from "../../components/SearchBar";
import Loader from "../../components/common/Loader";
import { DataGrid } from "@mui/x-data-grid";
import CompletionCell from "./Completion";
import ClientCell from "./Clients";
import { useTheme } from "../../ThemeContext";
import { SlOptions } from "react-icons/sl";
import { TbExternalLink } from "react-icons/tb";
import { useFetchUserAccessedProjectsQuery } from "../../slice/logdetailSlice";

function WeeklyTaskAllocation() {
    const location = useLocation();
    const isActiveTab = (path) => location.pathname.includes(path);
    const { isDarkMode } = useTheme();

    const dispatch = useDispatch();

    const login_user = useSelector((state) => state.selectOptions?.loginUserName);
    const { role: login_user_role } = login_user || {};
    const login_user_id = login_user?.id || login_user?.user_id;

    const { data: userAccessedProjects = [] } = useFetchUserAccessedProjectsQuery(undefined, {
        skip: login_user_role !== "MANAGER",
    });

    const [managers, setManagers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [projectCount, setProjectCount] = useState(0); // ✅ new state
    // const [rows, setRows] = useState([]); // ✅ to hold project data
    //  // ✔️ this is for proejct status code below 2 states
    const [allRows, setAllRows] = useState([]); // ✅ full unfiltered data from API
    const [rows, setRows] = useState([]); // ✅ used for individual row status update (optimistic)
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedManager, setSelectedManager] = useState("all");
    const [anchorEl, setAnchorEl] = useState(null);
    const menuOpen = Boolean(anchorEl);

    const activestatus = useSelector(
        (state) => state.selectOptions?.StatusOptions || []
    );
    const activityStatus = (activestatus || []).find(
        (status) => status.status_type === "PROJECT"
    );

    const getStatusColor = (statusName, isDark) => {
        const name = statusName?.toLowerCase() || "";
        if (name.includes("active")) {
            return isDark ? "#2ed15aa0" : "#27de3fff"; // Orange
        }
        if (name.includes("update")) {
            return isDark ? "#29b6f6" : "#0288d1"; // Blue
        }
        if (name.includes("complete")) {
            return isDark ? "#ba68c8" : "#9c27b0"; // Purple
        }
        if (name.includes("master")) {
            return isDark ? "#ef5350" : "#d32f2f"; // Red
        }
        return isDark ? "#fff" : "#000";
    };

    const statusList = activityStatus?.status_details?.map((status) => ({
        id: status.status_id,
        status_name: status.status_name,
        status_colour: getStatusColor(status.status_name, isDarkMode),
    })) || [];

    // Find Active status item for default selection
    const activeStatusItem = useMemo(() => {
        return (
            statusList.find((s) => s.status_name?.toLowerCase().trim() === "active") ||
            statusList.find(
                (s) =>
                    s.status_name?.toLowerCase().includes("active") &&
                    !s.status_name?.toLowerCase().includes("inactive")
            )
        );
    }, [statusList]);

    const hasUserChangedStatus = useRef(false);
    const [selectedStatus, setSelectedStatus] = useState(() => {
        const initialActive =
            activityStatus?.status_details?.find(
                (s) => s.status_name?.toLowerCase().trim() === "active"
            ) ||
            activityStatus?.status_details?.find(
                (s) =>
                    s.status_name?.toLowerCase().includes("active") &&
                    !s.status_name?.toLowerCase().includes("inactive")
            );
        return initialActive ? initialActive.status_id : "all";
    });

    useEffect(() => {
        if (!hasUserChangedStatus.current && activeStatusItem?.id) {
            setSelectedStatus(activeStatusItem.id);
        }
    }, [activeStatusItem]);


    // console.log(statusList)
    // console.log(searchTerm)
    const fetchOwnerLists = async () => {
        try {
            const response = await fetchAllEntities("getManagerName");
            if (response?.status) {
                const managerList = response.owner_name.filter(
                    (user) => user.role === "MANAGER"
                );
                setManagers(managerList);
                dispatch(setownerNameOptions(response.owner_name));
            }
        } catch (error) {
            toast.error(error.message);
            console.error("Error fetching ownerOptions:", error);
        }
    };

    const fetchProjectLists = async (search = "", managerId = "all") => {
        setLoading(true);
        try {
            const queryParams = new URLSearchParams();

            if (search) queryParams.append("search", search);
            if (managerId !== "all") queryParams.append("project_manager_id", managerId);

            const response = await getWeeklyTaskAllocation(
                `task-allocation/getWeeklyTaskAllocation?${queryParams.toString()}`
            );
            // console.log(response)
            if (response?.data) {
                // setProjectCount(response.data.total_count || 0);
                 setAllRows(response.data.projects || []);   // // ✔️ this is for proejct status code
                setRows(response.data.projects || []);
            }
        } catch (error) {
            toast.error(error.message);
            console.error("Error fetching projects:", error);
        } finally {
            setLoading(false);
        }
    };

// inside WeeklyTaskAllocation
// inside WeeklyTaskAllocation
// inside WeeklyTaskAllocation
// const handleExport = async (search = "", managerId = "all") => {
    const handleExport = async (search = "", managerId = "all", statusId = "all") => {  // // ✔️ this is for proejct status code
    setLoading(true);
    try {
        const queryParams = new URLSearchParams();

        const searchValue = typeof search === "string" ? search.trim() : "";
        queryParams.set("search", searchValue);
        queryParams.set("project_manager_id", managerId !== "all" ? String(managerId) : "");
        if (statusId !== "all") queryParams.set("status_id", String(statusId));  // // ✔️ this is for proejct status code
        queryParams.set("isExport", "true");

        const response = await getWeeklyTaskAllocation(
            `task-allocation/getWeeklyTaskAllocation?${queryParams.toString()}`
        );

        if (response?.data?.fileUrl) {
            // ✅ trigger download
            const link = document.createElement("a");
            link.href = response.data.fileUrl;
            link.setAttribute("download", "weekly_task_allocations.xlsx"); // suggested filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            toast.error("Export failed: No file URL returned.");
        }
    } catch (error) {
        toast.error(error.message);
        console.error("Error exporting weekly tasks:", error);
    } finally {
        setLoading(false);
        handleCloseMenu()
    }
};

    const handleManagerChange = (event) => {
        const value = event.target.value;
        setSelectedManager(value);

        // trigger fetch with current search + selected manager
        fetchProjectLists(searchTerm.trim(), value);
    };

    //  // ✔️ this is for proejct status code
    const handleStatusChange = (event) => {
        hasUserChangedStatus.current = true;
        const value = event.target.value;
        // ✅ Client-side filter only — no API call, no loading
        setSelectedStatus(value);
    };


    const handleSearchChange = async (event) => {
        const value = event.target.value;
        const trimmedValue = value.trim();
        setSearchTerm(value);

        // if (trimmedValue) {
        //   await fetchSearchedProjects(trimmedValue);
        // } else {
        //   await fetchProjects();
        // }

    };

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            // if (searchTerm.trim()) {  // ✔️ this is for proejct status code
            //     fetchProjectLists(searchTerm.trim());
            // } else {
            //     fetchProjectLists();
            // }
            fetchProjectLists(searchTerm.trim(), selectedManager);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchTerm]);

    // ✅ Client-side status filter — derived from allRows, no API call
    const filteredRows = useMemo(() => {
        if (selectedStatus === "all") return rows;
        return rows.filter(
            (row) => row.status_name?.status_id === selectedStatus
        );
    }, [rows, selectedStatus]);



    useEffect(() => {
        fetchOwnerLists();
        // fetchProjectLists();
    }, []);

    // useEffect(() => {
    //     fetchProjectLists(debouncedSearch);
    // }, [debouncedSearch]);


    // const updatestausofproject = async (projectId, statusId, completedPercentage) => {
    //   setLoading(true);
    //   try {
    //     const payload = {
    //       project_id: projectId,
    //       current_status_id: statusId,
    //       Completed_percentage: completedPercentage || 0,
    //     };

    //     const response = await updateWeeklyTaskAllocation(
    //       "task-allocation/updateWeeklyTaskAllocations",
    //       payload,
    //       login_user?.token // get token from redux or localStorage
    //     );

    //     console.log("Status updated successfully:", response);
    //     toast.success("Status updated successfully!");
    //   } catch (error) {
    //     toast.error("Failed to update status");
    //     console.error("Error updating project status:", error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    // const columns = [
      const columns = useMemo(() => [
        {
            field: "title",
            // headerName: `Projects (${projectCount})`,
             headerName: `Projects (${filteredRows.length})`, // // ✔️ this is for proejct status code
            width: 220,
            minWidth: 80, // 👈 prevents shrinking below 150px
            headerAlign: "center",
            align: "center",
            headerClassName: "sticky-column",
            cellClassName: "sticky-column",
            renderCell: (params) => {
                const { title, budget_type, project_id } = params.row;
                const formattedProjectId = project_id?.toString()?.replace(/\s+/g, "-");
                const budgetUrl = `/projects/projectDetail/${formattedProjectId}/budget`;

                const isAssigned = (() => {
                    if (login_user_role === "ADMIN") return true;
                    if (login_user_role === "MANAGER") {
                        const inAccessed = Array.isArray(userAccessedProjects) && userAccessedProjects.some(
                            (p) => String(p.project_id) === String(project_id)
                        );
                        const isManagerOfRow =
                            (params.row.managers?.id && Number(params.row.managers.id) === Number(login_user_id)) ||
                            (params.row.managers?.user_id && Number(params.row.managers.user_id) === Number(login_user_id)) ||
                            (params.row.project_manager_id && Number(params.row.project_manager_id) === Number(login_user_id));
                        return inAccessed || isManagerOfRow;
                    }
                    return false;
                })();

                return (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",   // ✅ center vertically in the row
                            alignItems: "flex-start",   // ✅ keep text left aligned
                            height: "100%",             // ✅ make div take full row height
                            width: "100%",
                            maxWidth: "100%",
                            margin: "0 10px",
                            overflow: "hidden",
                        }}
                    >
                        {/* First line: Title - single straight line with ellipsis + Tooltip for full name */}
                        <Tooltip title={title} placement="top" arrow>
                            {isAssigned ? (
                                <a
                                    href={budgetUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="project-title-link"
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        color: isDarkMode ? "#ffffff" : "#1e293b",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        textAlign: "left",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "6px",
                                        maxWidth: "100%",
                                        transition: "color 0.2s, text-decoration 0.2s",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.textDecoration = "underline";
                                        e.currentTarget.style.color = isDarkMode ? "#64b5f6" : "#0d6efd";
                                        const icon = e.currentTarget.querySelector(".ext-icon");
                                        if (icon) icon.style.opacity = "1";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.textDecoration = "none";
                                        e.currentTarget.style.color = isDarkMode ? "#ffffff" : "#1e293b";
                                        const icon = e.currentTarget.querySelector(".ext-icon");
                                        if (icon) icon.style.opacity = "0";
                                    }}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                    }}
                                >
                                    <span
                                        style={{
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            maxWidth: "100%",
                                        }}
                                    >
                                        {title}
                                    </span>
                                    <TbExternalLink
                                        className="ext-icon"
                                        size={14}
                                        style={{
                                            opacity: 0,
                                            transition: "opacity 0.2s ease-in-out",
                                            flexShrink: 0,
                                        }}
                                    />
                                </a>
                            ) : (
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        color: isDarkMode ? "#ffffff" : "#1e293b",
                                        textAlign: "left",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                        whiteSpace: "nowrap",
                                        maxWidth: "100%",
                                    }}
                                >
                                    {title}
                                </span>
                            )}
                        </Tooltip>

                        {/* Second line: Budget Type (only if available) */}
                        {budget_type && (
                            <span
                                style={{
                                    fontSize: "10px",
                                    color: "gray",
                                    marginTop: "4px",
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    maxWidth: "100%",
                                }}
                            >
                                {budget_type}
                            </span>
                        )}
                    </div>
                );
            },

        }
        ,
        {
            field: "status_name",
            headerName: "Project Status",
            width: 200,
            headerAlign: "center",
            align: "center",
            valueGetter: (params) => {
              const value = params?.status_name ?? "";
            //   console.log("valueGetter:", value);
              return value;
            },

            filterable: true,

            renderCell: (params) => {
                return (
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            width: "100%",
                            height: "100%",
                        }}
                    >
                        <FormControl size="small" sx={{ minWidth: 150 }}>
                            <Select
                                variant="standard"
                                disableUnderline
                                value={params.row.status_name?.status_id || ""}
                                onChange={async (e) => {
                                    const newStatusId = e.target.value;
                                    const oldStatusId = params.row.status_name?.status_id;

                                    // 🔹 Optimistic UI update
                                    setRows((prevRows) =>
                                        prevRows.map((row) =>
                                            row.project_id === params.row.project_id
                                                ? {
                                                    ...row,
                                                    status_name: {
                                                        ...row.status_name,
                                                        status_id: newStatusId,
                                                    },
                                                }
                                                : row
                                        )
                                    );

                                    try {
                                        const payload = {
                                            project_id: params.row.project_id,
                                            current_status_id: newStatusId,
                                            completed_percentage: params.row.completed_percentage || 0,
                                        };

                                        // 🔹 API call (your existing function)
                                        await updateWeeklyTaskAllocation(
                                            "task-allocation/updateWeeklyTaskAllocations",
                                            payload,
                                            login_user?.token
                                        );

                                        toast.success("Status updated successfully!");
                                    } catch (error) {
                                        toast.error("Failed to update status");

                                        // 🔹 Rollback on error
                                        setRows((prevRows) =>
                                            prevRows.map((row) =>
                                                row.project_id === params.row.project_id
                                                    ? {
                                                        ...row,
                                                        status_name: {
                                                            ...row.status_name,
                                                            status_id: oldStatusId,
                                                        },
                                                    }
                                                    : row
                                            )
                                        );
                                    }
                                }}
                                sx={{
                                    border: `1px solid ${
                                        statusList.find(
                                            (s) => s.id === params.row.status_name?.status_id
                                        )?.status_colour || "#d3d0d0ff"
                                    }`,
                                    borderRadius: "6px",
                                    padding: "1px",
                                    transition: "background-color 0.2s",
                                    "&:hover": {
                                        backgroundColor: isDarkMode
                                            ? "rgba(255, 255, 255, 0.08)"
                                            : "#f1f1f1",
                                    },
                                    "& .MuiSelect-select": {
                                        textAlign: "center",
                                        paddingRight: "28px !important",
                                        paddingLeft: "16px !important",
                                        //   fontWeight: "bold",
                                        color:
                                            statusList.find(
                                                (s) => s.id === params.row.status_name?.status_id
                                            )?.status_colour || "inherit",
                                        WebkitTextFillColor:
                                            statusList.find(
                                                (s) => s.id === params.row.status_name?.status_id
                                            )?.status_colour || "inherit",
                                    },
                                    "& .MuiSvgIcon-root": {
                                        color:
                                            statusList.find(
                                                (s) => s.id === params.row.status_name?.status_id
                                            )?.status_colour || (isDarkMode ? "#fff" : "#000"),
                                    },
                                }}
                            >
                                {statusList?.map((status) => (
                                    <MenuItem
                                        key={status.id}
                                        value={status.id}
                                        sx={{
                                            color: `${status.status_colour} !important`,
                                            WebkitTextFillColor: `${status.status_colour} !important`,
                                            backgroundColor: "transparent !important",
                                            fontWeight: "bold",
                                            "&.Mui-selected": {
                                                backgroundColor: "transparent !important",
                                                color: `${status.status_colour} !important`,
                                                WebkitTextFillColor: `${status.status_colour} !important`,
                                            },
                                            "&.Mui-selected:hover": {
                                                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.12) !important" : "rgba(0, 0, 0, 0.12) !important",
                                            },
                                            "&:hover": {
                                                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08) !important" : "rgba(0, 0, 0, 0.08) !important",
                                            },
                                        }}
                                    >
                                        {status.status_name}
                                    </MenuItem>
                                ))}
                            </Select>

                        </FormControl>
                    </Box>
                );
            },
        },
        {
            field: "total_budget",
            headerName: "Total Budget",
            width: 150,
            headerAlign: "center",
            align: "center",
            renderCell: ({ value }) => {
                const formatted = (value == null || value === "") ? "" : (Number(value) || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                return (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
                        <span style={{ fontWeight: "bold" }}>{formatted}</span>
                    </Box>
                );
            },
        },
        {
            field: "total_expenses",
            headerName: "Total Spent",
            width: 150,
            headerAlign: "center",
            align: "center",
            renderCell: ({ value }) => {
                if (value == null || value === "") {
                    return (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}></Box>
                    );
                }
                const num = Number(value) || 0;
                return (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
                        <span style={{ fontWeight: "bold" }}>
                            {num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                    </Box>
                );
            },
        },
        { 
            field: "profit",
            headerName: "Profit",
            width: 150,
            headerAlign: "center",
            align: "center",
            renderCell: ({ value }) => {
                if (value == null || value === "") {
                    return (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}></Box>
                    );
                }
                const num = Number(value) || 0;
                return (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
                        <span style={{ fontWeight: "bold", color: num >= 0 ? (isDarkMode ? "#4caf50" : "#2e7d32") : (isDarkMode ? "#ef5350" : "#d32f2f") }}>
                            {num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </span>
                    </Box>
                );
            },
        },
        {
            field: "profit_percentage",
            headerName: "Profit %",
            width: 130,
            headerAlign: "center",
            align: "center",
            renderCell: ({ value }) => {
                if (value == null || value === "") {
                    return (
                        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}></Box>
                    );
                }
                const num = Number(value) || 0;
                return (
                    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%", height: "100%" }}>
                        <span style={{ fontWeight: "bold", color: num >= 0 ? (isDarkMode ? "#4caf50" : "#2e7d32") : (isDarkMode ? "#ef5350" : "#d32f2f") }}>
                            {num.toFixed(2)}%
                        </span>
                    </Box>
                );
            },
        },
        {
            field: "managers",
            headerName: "Project Manager",
            width: 200,
            headerAlign: "center",
            align: "center",
           valueGetter: (params) => {
           //   console.log("valueGetter param:", params);
               const value = params?.name ?? "";
           //   console.log("valueGetter:", value);
             return value;
           },

            renderCell: (params) => (
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center", // horizontal center
                        alignItems: "center",     // vertical center
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <Typography variant="body2" sx={{ textAlign: "center" }}>
                        {params.row.managers?.name || "—"}
                    </Typography>
                </Box>
            ),
        },
        {
            field: "added_users",
            headerName: "Developers",
            width: 600,
            minWidth: 200,
            headerAlign: "center",
            align: "center",
            filterable: true,
            valueGetter: (params) => {
              const clients = params || [];
              return clients.map(c => c.name).join(", ");
            },
            renderCell: (params) => (
                <DeveloperCell developers={params.row.added_users || []} />
            ),
        },

        {
            field: "completed_percentage",
            headerName: "% Completion",
            width: 200,
            headerAlign: "center",
            align: "center",
            filterable: false,
            renderCell: (params) => (
                <CompletionCell
                    value={params.row.completed_percentage}
                    row={params.row}
                    setRows={setRows}
                    login_user={login_user}
                />
            ),
        },
        {
            field: "clients",
            headerName: "Clients",
            width: 400,
            minWidth: 150,
            headerAlign: "center",
            align: "center",
            valueGetter: (params) => {
            const clients = params || [];
             return clients.map(c => c.name).join(", ");
            },
            renderCell: (params) => (
                <ClientCell clients={params.row.clients || "—"} />
            ),
        },
    // ];
    ], [filteredRows.length, statusList, isDarkMode, setRows, login_user]);


    return (
        <>
            <div style={{ height: "100%", width: "100%" }} className="bg-white p-3">
                {/* <div className="d-flex justify-content-between align-items-center pb-2"> */}
                <Box
                //  // ✔️ this is for proejct status code
                    className="d-flex justify-content-between align-items-center"
                    sx={{
                        border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                        borderRadius: "6px",
                        padding: "12px 16px",
                        marginBottom: "16px",
                        backgroundColor: isDarkMode ? "transparent" : "#fff",
                    }}
                >

                    {/* Left Section: Project Manager + Project Status Dropdowns */}
                    <div className="d-flex align-items-center" style={{ gap: 5 }}>

                        {/* Project Manager Dropdown */}
                        <div className="d-flex align-items-center" style={{ gap: 5 }}>
                            {/* <Typography
                                variant="body2"
                                color="textSecondary"
                                sx={{ whiteSpace: "nowrap", fontSize: "0.95rem" }}
                            >
                                Project Manager
                            </Typography> */}
                            <FormControl>
                                <Select
                                    displayEmpty
                                    value={selectedManager}
                                    onChange={handleManagerChange}
                                    size="small"
                                sx={{ minWidth: 150 }}
                                >
                                    <MenuItem value="all">All Project Managers</MenuItem>
                                    {managers.map((option) => (
                                        <MenuItem key={option.user_id} value={option.user_id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        {/* Project Status Dropdown   // ✔️ this is for proejct status code*/}  
                        <div className="d-flex align-items-center ms-2">
                            <FormControl>
                                <Select
                                    displayEmpty
                                    value={selectedStatus}
                                    onChange={handleStatusChange}
                                    size="small"
                                    sx={{ minWidth: 130 }}
                                >
                                    <MenuItem value="all">All Status</MenuItem>
                                    {statusList?.map((status) => (
                                        <MenuItem
                                            key={status.id}
                                            value={status.id}
                                            sx={{ color: status.status_colour, fontWeight: "bold" }}
                                        >
                                            {status.status_name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>  {/*  // ✔️ this is for proejct status code */}

                    </div>


                    {/* Right Section: Search Input */}
                    <div className="d-flex align-items-center">
                        <SearchBar
                            placeholder="Search Projects"
                            searchTerm={searchTerm}
                            onSearchChange={handleSearchChange}
                        />
                        <Tooltip title="Export">
                            <IconButton
                                className="d-flex align-items-center justify-content-center ms-3"
                                sx={{
                                    backgroundColor: isDarkMode
                                        ? "rgba(67, 105, 255, 0.08)"
                                        : "#F1F5FF",
                                    borderRadius: "50%",
                                    width: "39px",
                                    height: "39px",
                                    "&:hover": {
                                        backgroundColor: "var(--icon-hover-bg)",
                                    },
                                }}
                                onClick={handleMenuOpen}
                            >
                                <SlOptions size={20} className="text-rgbr-blue " />
                            </IconButton>
                        </Tooltip>
                        <Menu
                            anchorEl={anchorEl}
                            open={menuOpen}
                            onClose={handleCloseMenu}
                        >
                            {/* <MenuItem onClick={() => handleExport(searchTerm, selectedManager)}>*/}
                            <MenuItem onClick={() => handleExport(searchTerm, selectedManager, selectedStatus)}>     {/*✔️ this is for proejct status code */}
                                Export 
                            </MenuItem>
                        </Menu>
                    </div>
                {/* </div> */}
            </Box>
            
                {loading ? (
                    <Loader />
                ) : (
                    <div className="mt-2" style={{ height: "calc(100vh - 60px)", minHeight: "690px", width: "100%" }}>
                        <DataGrid
                            // rows={rows}
                            rows={filteredRows} // ✔️ this is for proejct status code
                            columns={columns}
                            getRowId={(row) => row.project_id}
                            // disableColumnMenu
                            // disableColumnSorting
                            // disableColumnFilter
                            // disableColumnSelector
                            getRowHeight={() => 'auto'} // dynamic row height
                            disableRowSelectionOnClick
                            sx={{
                                height: "100%",
                                width: "100%",
                                border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                                "& .MuiDataGrid-columnHeaders": {
                                    backgroundColor: isDarkMode ? "var(--cell-bg-color, #1e1e1e)" : "#ffffff",
                                    fontWeight: "bold",
                                    fontSize: "14px",
                                },
                                "& .MuiDataGrid-cell": {
                                    borderRight: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                                    fontSize: "13px",
                                    color: isDarkMode ? "#f2f1f1" : "#444",
                                    whiteSpace: "normal !important",
                                    wordBreak: "break-word",
                                    display: "block",
                                    padding: "6px 8px",
                                    minHeight: "80px", // ✅ enforce minimum 80px per cell
                                    lineHeight: "1.4",
                                },
                                "& .MuiDataGrid-row:hover": {
                                    backgroundColor: isDarkMode ? "var(--hover-bg-color, #333)" : "#f9f9f9",
                                },
                                // 🔥 Freeze First Column (Projects) 🔥
                                "& .MuiDataGrid-cell.sticky-column": {
                                    position: "sticky !important",
                                    left: "0 !important",
                                    zIndex: 2,
                                    backgroundColor: isDarkMode ? "var(--cell-bg-color, #1e1e1e) !important" : "#ffffff !important",
                                },
                                // 🔥 Freeze Top-Left Header (Intersection of Row 1 & Col 1) 🔥
                                "& .MuiDataGrid-columnHeaders .sticky-column": {
                                    position: "sticky !important",
                                    left: "0 !important",
                                    zIndex: "5 !important",
                                    backgroundColor: isDarkMode ? "var(--cell-bg-color, #1e1e1e) !important" : "#ffffff !important",
                                },
                                // Row hover background for sticky column cells
                                "& .MuiDataGrid-row:hover .sticky-column": {
                                    backgroundColor: isDarkMode ? "var(--hover-bg-color, #333) !important" : "#f9f9f9 !important",
                                },
                                // Show external link icon on project title hover
                                "& .project-title-link:hover .ext-icon": {
                                    opacity: "1 !important",
                                },
                            }}
                        />
                    </div>
                )}
            </div>
        </>

    );
}

export default WeeklyTaskAllocation;
